import { LinksAppointment } from '~/domain/usecases/appointment/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteLinksAppointment implements LinksAppointment {
  private readonly url: string;

  private readonly httpClient: HttpClient<LinksAppointment.Model>;

  constructor(url: string, httClient: HttpClient<LinksAppointment.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  links = async (
    params: LinksAppointment.Params,
  ): Promise<LinksAppointment.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{appointmentId}', params.appointmentId),
      method: 'get',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
